import type { Components } from 'react-markdown';

/**
 * `react-markdown` component map for legal agreement text. Spacing comes from
 * the parent's `space-y-*` and padding, so no element sets margins.
 */
const agreementMarkdownComponents: Components = {
  // Sections sit under the dialog's h2 title, so render them one level down.
  h2: ({ children }) => (
    <h3 className="pt-2 text-base font-semibold text-neutral-900">
      {children}
    </h3>
  ),
  p: ({ children }) => <p>{children}</p>,
  ul: ({ children }) => (
    <ul className="list-disc space-y-1 pl-6">{children}</ul>
  ),
  ol: ({ children }) => (
    <ol className="list-decimal space-y-1 pl-6">{children}</ol>
  ),
  li: ({ children }) => <li>{children}</li>,
  strong: ({ children }) => (
    <strong className="font-semibold">{children}</strong>
  ),
  em: ({ children }) => <em className="italic">{children}</em>,
  blockquote: ({ children }) => (
    <blockquote className="space-y-3 border-l-4 border-neutral-200 pl-4 text-neutral-600">
      {children}
    </blockquote>
  ),
  a: ({ href, children }) => (
    <a
      href={href}
      target="_blank"
      rel="noopener noreferrer"
      className="font-medium text-blue-600"
    >
      {children}
    </a>
  ),
};

export default agreementMarkdownComponents;
